import React, {Component, Fragment, useState, useEffect} from "react"
import {Link, NavLink} from "react-router-dom"
import {Button, Icon} from "semantic-ui-react"
import categoryStore from "stores/categoryStore"
import Sidebar from "components/Sidebar/Sidebar"
import CartMini from "components/Cart/CartMini"
import app from "app.controller"
import OrderlistSelection from "components/Orderlist/OrderlistSelection"
import Header from "components/Header/Header"
import Footer from "components/Footer/Footer"
import shop from "shop/shop"
import "style/util.scss"
import "./PageLayout.scss"

class PageLayout extends Component {
  render() {
    return (
      <div className="PageLayout">
        <OrderlistSelection/>

        {/* SHOPPING CART */}
        <Sidebar open={app.sidebar.open} toggle={app.sidebar.toggle} close={app.sidebar.close}>
          <CartMini/>
        </Sidebar>

        <Sidebar left open={app.sidebarLeft.open} toggle={app.sidebarLeft.toggle} close={app.sidebarLeft.close}>
          <SidebarLeft/>
        </Sidebar>

        <Header/>
        <div className="page-content min-vh-100">
          {this.props.children}
        </div>
        <Footer/>
      </div>
    )
  }
}

// ── Helpers ────────────────────────────────────────────────────────────────

const getActiveChildren = (category) =>
  (category.children || []).filter(c => c.active && !c.isHidden)

const getCategoryUrl = (category) => {
  let ttl = 10
  let parents = []
  let current = category
  while (current && current.parent && ttl--) {
    parents.push(current.parent)
    current = shop.categoriesById.get(current.parent)
  }
  parents.reverse()
  const parentSegment = category.parent ? `/${parents.join("/")}` : ""
  return `/collection${parentSegment}/${category.map_id}/`
}

// ── Mobile Category Drill-Down ─────────────────────────────────────────────

const MobileCategoryNav = ({categories, onClose}) => {
  const rootItems = (categories || []).filter(c => c.active && !c.isHidden)

  const [stack, setStack] = useState([{items: rootItems, title: null}])

  useEffect(() => {
    setStack([{items: (categories || []).filter(c => c.active && !c.isHidden), title: null}])
  }, [categories])

  const currentIdx = stack.length - 1
  const total = stack.length

  const pushLevel = (cat) => {
    const children = getActiveChildren(cat)
    if (!children.length) return
    setStack(prev => [...prev, {items: children, title: cat.desc.short_des}])
  }

  const popLevel = () => {
    setStack(prev => prev.length > 1 ? prev.slice(0, -1) : prev)
  }

  return (
    <div className="mobile-cat-nav">
      <div
        className="mobile-cat-track"
        style={{
          width: `${total * 100}%`,
          transform: `translateX(-${currentIdx * (100 / total)}%)`,
        }}
      >
        {stack.map((panel, idx) => (
          <div
            key={idx}
            className="mobile-cat-panel"
            style={{width: `${100 / total}%`}}
          >
            {panel.title && (
              <div className="mobile-cat-header">
                <button className="mobile-cat-chevron" onClick={popLevel}>
                  <Icon name="chevron left"/><span className="mobile-cat-header-title">{panel.title}</span>
                </button>
                
              </div>
            )}

            {panel.items.map(cat => {
              const hasChildren = getActiveChildren(cat).length > 0
              return (
                <div key={cat.map_id} className="mobile-cat-item">
                  <NavLink
                    to={getCategoryUrl(cat)}
                    onClick={onClose}
                    className="mobile-cat-link"
                  >
                    {cat.desc.short_des}
                  </NavLink>
                  {hasChildren && (
                    <button className="mobile-cat-chevron" onClick={() => pushLevel(cat)}>
                      <Icon name="chevron right"/>
                    </button>
                  )}
                </div>
              )
            })}
          </div>
        ))}
      </div>
    </div>
  )
}

// ── SidebarLeft ────────────────────────────────────────────────────────────

const SidebarLeft = () => {
  const categoryData = categoryStore.categories
  const {hash} = categoryStore

  return (
    <div className="SidebarLeft h-100 flex flex-column">
      {/* Header */}
      <div className="sidebar-left-header">
        <button className="sidebar-close-btn" onClick={app.sidebarLeft.toggle.dispatch}>
          <Icon name="close"/>
        </button>
      </div>

      {/* Category Navigation */}
      <div className="sidebar-left-body">
        <MobileCategoryNav
          key={hash}
          categories={categoryData}
          onClose={app.sidebarLeft.close.dispatch}
        />
        {shop.session && shop.session.handId && shop.session.shopuser && shop.session.shopuser.handid && (
          <div className="raederHeaderMenuAccountMobile">
            <div className="fw5 pa1">
              {translate("Aktuell gewählter Kundenaccount:")}{" "}
              {shop.session.value && shop.session.value.map_id ? shop.session.value.map_id : translate("Kein Kundenaccount gewählt")}
              {" - "}
              {shop.session.value && shop.session.value.title ? shop.session.value.title : "-"}
            </div>
            <Button primary as={Link} to="/login/accounts" onClick={app.sidebarLeft.close.dispatch}>
              {translate("Kunden wechseln")}
            </Button>
          </div>
        )}
      </div>

      {/* Quick Actions */}
      {/*<div className="sidebar-left-actions">
        {shop.session && shop.session.shopuser && !shop.session.shopuser.guest ? (
          <Button
            className="sidebar-action-btn"
            onClick={app.sidebarLeft.close.dispatch}
            primary
            as={Link}
            to="/account"
          >
            <Icon name="user circle" size="large" style={{margin: 0}}/>
          </Button>
        ) : (
          <Button
            className="sidebar-action-btn"
            onClick={app.sidebarLeft.close.dispatch}
            primary
            as={Link}
            to="/login"
          >
            <Icon name="user circle" size="large" style={{margin: 0}}/>
          </Button>
        )}

        <Button
          className="sidebar-action-btn"
          onClick={app.sidebarLeft.close.dispatch}
          primary
          as={Link}
          to="/search/"
        >
          <Icon name="search" size="large" style={{margin: 0}}/>
        </Button>

        {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && (
          <Fragment>
            <Button
              className="sidebar-action-btn"
              onClick={app.sidebarLeft.close.dispatch}
              primary
              as={Link}
              to="/orderlist"
            >
              <Icon name="heart" size="large" style={{margin: 0}}/>
            </Button>
            <Button
              className="sidebar-action-btn"
              onClick={app.sidebarLeft.close.dispatch}
              primary
              as={Link}
              to="/quickorder"
            >
              <Icon name="shopping basket" size="large" style={{margin: 0}}/>
            </Button>
          </Fragment>
        )}
      </div> */}
    </div>
  )
}

export default PageLayout



// WEBPACK FOOTER //
// ./src/theme/trendimport.test/layout/PageLayout.js